import { adminApiFetch } from '@/services/adminApiFetch';

export interface AdminUser {
  id: number;
  email: string;
  role: string;
}

export interface AdminLoginResponse {
  access_token: string;
  token_type: 'Bearer';
  admin: AdminUser;
}

export const adminAuthService = {
  login(email: string, password: string): Promise<AdminLoginResponse> {
    return adminApiFetch<AdminLoginResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      skipAuth: true,
    });
  },

  me(): Promise<AdminUser> {
    return adminApiFetch<AdminUser>('/auth/me');
  },
};
